import './clear.scss'

const Clear = () => {
  return <div className="clear" />
};

export default Clear;
